import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 检查设置
import checkDevice from './utils/checkDevice'
if(checkDevice()==='mobile'){
  window.location.href='/mobile'
}
// UI组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {Message} from 'element-ui';

Vue.use(ElementUI);

// 加入动画
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.component(CollapseTransition.name, CollapseTransition)
// 加入自定义字体
import '../public/css/myfont.css'

Vue.config.productionTip = false
//禁用右键
document.oncontextmenu = function(e){
    Message.info({
        showClose: true,
        message: '感谢支持',
        type: 'info'
    });
    // let event = e || window.event;
    // event.returnValue = false;
    return false;
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
